import ConsumerDashboard from "./ConsumerDashboard"

export default function Dashboard() {
  const user = localStorage.getItem('user')
  const userRoleSlug = localStorage.getItem('user_role_slug')
  return (
    <div>
      { userRoleSlug !== 'consumer' &&
        <>
          <h2 className="text-2xl font-bold mb-4">Dashboard</h2>
          <div className="text-xl font-semibold mb-4">Selamat datang, {user}</div>
        </>
      }
      { userRoleSlug === 'consumer' &&
        <>
          <ConsumerDashboard />
        </>
      }
    </div>
  )
}
